import React from 'react';

/**
 * SearchBox (C2 / FT8) — controlled board search input. Purely client-side: the
 * query is matched against bed label / patient / IP / room / ward in WardGroup,
 * which auto-expands a collapsed matching ward and highlights the hits. No
 * network on keystroke.
 */
export default function SearchBox({ value = '', onChange }) {
  return (
    <input
      type="search"
      aria-label="Search beds"
      data-testid="board-search"
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder="Search bed, patient, IP or ward…"
      className="w-full max-w-xs rounded-lg border border-slate-300 bg-white px-2.5 py-2 text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-100"
    />
  );
}
